module.exports = __webpack_public_path__ + "images/img_1_3-1aa666a044.png";